// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
  padding: 20px;
}

.create-post-modal {
  background: var(--card-bg);
  border-radius: 16px;
  width: 100%;
  max-width: 720px;
  max-height: 98vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* Modal Header */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background: var(--hover-bg);
}

.close-btn svg {
  width: 20px;
  height: 20px;
  color: var(--text-primary);
}

/* Post Type Toggle */
.post-type-toggle {
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color);
}

.toggle-btn {
  flex: 1 1;
  padding: 10px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.toggle-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

/* Form */
.post-form {
  padding: 24px;
  display: flex;
  flex-direction: column;
  /*gap: 16px;*/
}

.form-group {
  display: flex;
  flex-direction: column;
  /*gap: 8px;*/
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.title-input,
.tags-input,
.community-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
}

.title-input:focus,
.tags-input:focus,
.community-select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.body-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
}

.body-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.char-counter {
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: var(--text-secondary);
}

.char-counter .over-limit {
  color: #ff4444;
  font-weight: 600;
}

.community-select {
  cursor: pointer;
}

.community-select option {
  background: var(--card-bg);
  color: var(--text-primary);
}

/* Error Message */
.error-message {
  padding: 12px 16px;
  background: rgba(255, 68, 68, 0.1);
  border: 1px solid #ff4444;
  border-radius: 8px;
  color: #ff4444;
  font-size: 14px;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 8px;
}

.cancel-form-btn,
.submit-form-btn,
.advanced-btn,
.blwh-btn, .btn-beneficiary-increment, .btn-beneficiary-xs {
  padding: 10px 24px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.posting-actions {
  display: flex;
  gap: 8px;
}

.btn-danger {
  padding:8px 12px !important;
}

.cancel-form-btn, .advanced-btn, .blwh-btn, .btn-beneficiary-increment, .btn-beneficiary-xs {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 8px;
}

.cancel-form-btn:hover, .advanced-btn:hover, .blwh-btn:hover, .btn-beneficiary-increment:hover, .btn-beneficiary-xs:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.btn-danger:hover {
  background: var(--error-color);
  color:var(--overlay-strong);
}

.submit-form-btn {
  background: var(--primary-color);
  color: var(--text-primary);
}

.submit-form-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.submit-form-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.benef-summary {
  margin-top: 8px;
  font-size: 14px;
  color: var(--text-secondary);
}

.form-group.include-blog-group {
  display: flex;
  justify-content: center;
  height: 40px;
}

.include-blog-group .form-label {
  display: flex;
  align-items: center;
}

.include-blog-group .form-label input {
  width:unset;
}

.include-blog-group .form-label span {
  width:100%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-backdrop {
    padding: 0;
  }

  .create-post-modal {
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .modal-header,
  .post-type-toggle,
  .post-form {
    padding: 16px;
  }
}

/* Poll Creator Section */
.poll-creator-toggle-row {
  margin: 12px 0 6px 0;
  display: flex;
  align-items: center;
}

.poll-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: var(--bg-secondary, rgba(255, 255, 255, 0.05));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));
  border-radius: 20px;
  color: var(--text-secondary, #a0a0a0);
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.poll-toggle-btn:hover {
  color: var(--text-primary, #ffffff);
  border-color: var(--accent-color, #e31337);
}

.poll-toggle-btn.active {
  background: var(--accent-color-dim, rgba(227, 19, 55, 0.15));
  border-color: var(--accent-color, #e31337);
  color: var(--accent-color, #e31337);
}

.poll-creator-box {
  margin: 10px 0 16px 0;
  padding: 16px;
  background: var(--bg-secondary, rgba(255, 255, 255, 0.03));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.poll-creator-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary, #ffffff);
  margin: 0;
}

.poll-input-field {
  width: 100%;
  padding: 8px 12px;
  background: var(--bg-tertiary, rgba(255, 255, 255, 0.05));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));
  border-radius: 8px;
  color: var(--text-primary, #ffffff);
  font-size: 0.9rem;
  box-sizing: border-box;
}

.poll-input-field:focus {
  outline: none;
  border-color: var(--accent-color, #e31337);
}

.poll-choices-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.poll-choice-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.poll-remove-choice-btn {
  background: transparent;
  border: none;
  color: var(--text-secondary, #888);
  font-size: 1.3rem;
  cursor: pointer;
  padding: 0 6px;
  line-height: 1;
}

.poll-remove-choice-btn:hover {
  color: var(--accent-color, #e31337);
}

.poll-add-choice-btn {
  align-self: flex-start;
  background: transparent;
  border: 1px dashed var(--border-color, rgba(255, 255, 255, 0.2));
  border-radius: 6px;
  color: var(--text-secondary, #a0a0a0);
  padding: 6px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
}

.poll-add-choice-btn:hover {
  border-color: var(--accent-color, #e31337);
  color: var(--text-primary, #ffffff);
}

.poll-duration-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.88rem;
  color: var(--text-secondary, #a0a0a0);
}

.poll-duration-input {
  width: 75px;
  padding: 6px 8px;
  background: var(--bg-tertiary, rgba(255, 255, 255, 0.05));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));
  border-radius: 6px;
  color: var(--text-primary, #ffffff);
  font-size: 0.9rem;
  text-align: center;
}

.poll-duration-select {
  padding: 6px 10px;
  background: var(--bg-tertiary, #222);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));
  border-radius: 6px;
  color: var(--text-primary, #ffffff);
  font-size: 0.9rem;
  cursor: pointer;
}

.poll-duration-hint {
  font-size: 0.8rem;
  color: var(--text-secondary, #888);
}

`, "",{"version":3,"sources":["webpack://./src/components/CreatePostModal/CreatePostModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0DAA0D;EAC1D,gEAAgE;EAChE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,4DAA4D;EAC5D,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0DAA0D;EAC1D,gEAAgE;EAChE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yDAAyD;EACzD,gEAAgE;EAChE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gEAAgE;EAChE,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yDAAyD;EACzD,gEAAgE;EAChE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gEAAgE;EAChE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC","sourcesContent":[".modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 4000;\r\n  padding: 20px;\r\n}\r\n\r\n.create-post-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  max-width: 720px;\r\n  max-height: 98vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Modal Header */\r\n.modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.modal-header h2 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 8px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.close-btn svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Post Type Toggle */\r\n.post-type-toggle {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.toggle-btn {\r\n  flex: 1;\r\n  padding: 10px 16px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.toggle-btn:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.toggle-btn.active {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n/* Form */\r\n.post-form {\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /*gap: 16px;*/\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /*gap: 8px;*/\r\n}\r\n\r\n.form-label {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.title-input,\r\n.tags-input,\r\n.community-select {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n}\r\n\r\n.title-input:focus,\r\n.tags-input:focus,\r\n.community-select:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.body-textarea {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  resize: vertical;\r\n  min-height: 100px;\r\n}\r\n\r\n.body-textarea:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.char-counter {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.char-counter .over-limit {\r\n  color: #ff4444;\r\n  font-weight: 600;\r\n}\r\n\r\n.community-select {\r\n  cursor: pointer;\r\n}\r\n\r\n.community-select option {\r\n  background: var(--card-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  padding: 12px 16px;\r\n  background: rgba(255, 68, 68, 0.1);\r\n  border: 1px solid #ff4444;\r\n  border-radius: 8px;\r\n  color: #ff4444;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Form Actions */\r\n.form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  padding-top: 8px;\r\n}\r\n\r\n.cancel-form-btn,\r\n.submit-form-btn,\r\n.advanced-btn,\r\n.blwh-btn, .btn-beneficiary-increment, .btn-beneficiary-xs {\r\n  padding: 10px 24px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.posting-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-danger {\r\n  padding:8px 12px !important;\r\n}\r\n\r\n.cancel-form-btn, .advanced-btn, .blwh-btn, .btn-beneficiary-increment, .btn-beneficiary-xs {\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border-color);\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.cancel-form-btn:hover, .advanced-btn:hover, .blwh-btn:hover, .btn-beneficiary-increment:hover, .btn-beneficiary-xs:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.btn-danger:hover {\r\n  background: var(--error-color);\r\n  color:var(--overlay-strong);\r\n}\r\n\r\n.submit-form-btn {\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.submit-form-btn:hover:not(:disabled) {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.submit-form-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.benef-summary {\r\n  margin-top: 8px;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.form-group.include-blog-group {\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 40px;\r\n}\r\n\r\n.include-blog-group .form-label {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.include-blog-group .form-label input {\r\n  width:unset;\r\n}\r\n\r\n.include-blog-group .form-label span {\r\n  width:100%;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .modal-backdrop {\r\n    padding: 0;\r\n  }\r\n\r\n  .create-post-modal {\r\n    max-width: 100%;\r\n    max-height: 100vh;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .modal-header,\r\n  .post-type-toggle,\r\n  .post-form {\r\n    padding: 16px;\r\n  }\r\n}\r\n\r\n/* Poll Creator Section */\r\n.poll-creator-toggle-row {\r\n  margin: 12px 0 6px 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.poll-toggle-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 14px;\r\n  background: var(--bg-secondary, rgba(255, 255, 255, 0.05));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));\r\n  border-radius: 20px;\r\n  color: var(--text-secondary, #a0a0a0);\r\n  font-size: 0.88rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.poll-toggle-btn:hover {\r\n  color: var(--text-primary, #ffffff);\r\n  border-color: var(--accent-color, #e31337);\r\n}\r\n\r\n.poll-toggle-btn.active {\r\n  background: var(--accent-color-dim, rgba(227, 19, 55, 0.15));\r\n  border-color: var(--accent-color, #e31337);\r\n  color: var(--accent-color, #e31337);\r\n}\r\n\r\n.poll-creator-box {\r\n  margin: 10px 0 16px 0;\r\n  padding: 16px;\r\n  background: var(--bg-secondary, rgba(255, 255, 255, 0.03));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));\r\n  border-radius: 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.poll-creator-title {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary, #ffffff);\r\n  margin: 0;\r\n}\r\n\r\n.poll-input-field {\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  background: var(--bg-tertiary, rgba(255, 255, 255, 0.05));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));\r\n  border-radius: 8px;\r\n  color: var(--text-primary, #ffffff);\r\n  font-size: 0.9rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.poll-input-field:focus {\r\n  outline: none;\r\n  border-color: var(--accent-color, #e31337);\r\n}\r\n\r\n.poll-choices-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.poll-choice-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.poll-remove-choice-btn {\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--text-secondary, #888);\r\n  font-size: 1.3rem;\r\n  cursor: pointer;\r\n  padding: 0 6px;\r\n  line-height: 1;\r\n}\r\n\r\n.poll-remove-choice-btn:hover {\r\n  color: var(--accent-color, #e31337);\r\n}\r\n\r\n.poll-add-choice-btn {\r\n  align-self: flex-start;\r\n  background: transparent;\r\n  border: 1px dashed var(--border-color, rgba(255, 255, 255, 0.2));\r\n  border-radius: 6px;\r\n  color: var(--text-secondary, #a0a0a0);\r\n  padding: 6px 12px;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.poll-add-choice-btn:hover {\r\n  border-color: var(--accent-color, #e31337);\r\n  color: var(--text-primary, #ffffff);\r\n}\r\n\r\n.poll-duration-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  font-size: 0.88rem;\r\n  color: var(--text-secondary, #a0a0a0);\r\n}\r\n\r\n.poll-duration-input {\r\n  width: 75px;\r\n  padding: 6px 8px;\r\n  background: var(--bg-tertiary, rgba(255, 255, 255, 0.05));\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));\r\n  border-radius: 6px;\r\n  color: var(--text-primary, #ffffff);\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n}\r\n\r\n.poll-duration-select {\r\n  padding: 6px 10px;\r\n  background: var(--bg-tertiary, #222);\r\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.15));\r\n  border-radius: 6px;\r\n  color: var(--text-primary, #ffffff);\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.poll-duration-hint {\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary, #888);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
